import { useCallback, useState } from 'preact/hooks';
import type { StreamProvider } from '@vgtv/api-client';

import { isAndroid, isHermesApp } from '../../../utils/device';

import { useProvider } from './useProvider';

type PaywallType = 'popup' | 'fallback' | 'native' | 'disabled';

const NO_SALESPOSTER_PROVIDERS: StreamProvider[] = ['ab', 'svd'];

export const usePaywallHandlers = (
  subscriptionUrl?: string,
  { isUrlOverridden = false }: { isUrlOverridden?: boolean } = {}
) => {
  const { configProvider } = useProvider();

  const [defaultPaywallType, setPaywallType] = useState<PaywallType>(() => {
    if (isHermesApp) {
      return isAndroid ? 'disabled' : 'native';
    }

    if (NO_SALESPOSTER_PROVIDERS.includes(configProvider)) {
      return 'fallback';
    }

    return 'popup';
  });

  // A URL provided by the host always wins, also in the native apps.
  const paywallType: PaywallType =
    isUrlOverridden && subscriptionUrl ? 'fallback' : defaultPaywallType;

  const [isSalesPosterOpen, setIsSalesPosterOpen] = useState(false);

  const handlePosterLoadFailure = useCallback(() => {
    setPaywallType('fallback');
  }, []);

  const handlePosterCloseClick = useCallback(() => {
    setIsSalesPosterOpen(false);
  }, []);

  const handleSubscribeClick = useCallback(() => {
    if (paywallType === 'popup') {
      setIsSalesPosterOpen(true);
    } else if (
      (paywallType === 'fallback' || paywallType === 'native') &&
      subscriptionUrl
    ) {
      window.top!.location = subscriptionUrl;
    }
  }, [paywallType, subscriptionUrl]);

  return {
    paywallType,
    isSalesPosterOpen,
    handlePosterLoadFailure,
    handlePosterCloseClick,
    handleSubscribeClick,
  };
};
